/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactGroupCreation
 */
export interface APIContactGroupCreation {
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupCreation
     */
    readonly self: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContactGroupCreation
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroupCreation
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContactGroupCreation
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupCreation
     */
    name: string;
}

/**
 * Check if a given object implements the APIContactGroupCreation interface.
 */
export function instanceOfAPIContactGroupCreation(value: object): value is APIContactGroupCreation {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIContactGroupCreationFromJSON(json: any): APIContactGroupCreation {
    return APIContactGroupCreationFromJSONTyped(json, false);
}

export function APIContactGroupCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactGroupCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contacts': json['contacts'] == null ? undefined : json['contacts'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APIContactGroupCreationToJSON(value?: Omit<APIContactGroupCreation, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'],
        'name': value['name'],
    };
}

